module.exports = __webpack_public_path__ + "img/icon_dialog_svip_level2.c297f3bc.png";